export enum PolicyType {
    Annuity = "annuity",
    WholeLife = "whole",
    Term = "term",
    Universal = "universal",
    CashBackOption = "cbo",
    IUL = "iul"
}